<div class="login-modal">
    <a (click)="onCancelClick(); $event.stopPropagation()" class="close"
        ><i class="material-icons">clear</i></a
    >
    <h1 class="dialog-title-text text-center">Sign in to FBOLinx</h1>
    <div class="mt-1 mb-2" style="max-width: 600px">
        <form (ngSubmit)="onSubmit()" [formGroup]="loginForm">
            <mat-form-field>
                <input
                    formControlName="username"
                    matInput
                    placeholder="Username"
                    required
                />
            </mat-form-field>

            <mat-form-field>
                <input
                    formControlName="password"
                    matInput
                    placeholder="Password"
                    required
                    type="password"
                />
                <mat-hint *ngIf="error" class="text-danger">{{
                    error
                }}</mat-hint>
            </mat-form-field>

            <div class="text-left mb-module">
                <mat-checkbox formControlName="remember">
                    Keep me signed in
                </mat-checkbox>
            </div>

            <button
                class="mt-3 login-button"
                color="accent"
                mat-flat-button
                type="submit"
            >
                Sign In
            </button>
        </form>
    </div>
    <div>
        <div class="text-center col-12">
            <a (click)="openRequestDemo()" routerLink=".">Request Demo</a>
            <span class="divider"></span>
            <a (click)="openForgotPassword()" routerLink="."
                >Forgot your password?</a
            >
        </div>
    </div>
    <div *ngIf="newDesignUrl" class="text-center new-design-switch">
        <a (click)="onTryNewDesign()" style="cursor: pointer"
            >Sign in with the new FBOLinx design →</a
        >
    </div>
</div>
